import { USER_ROLES, type UserRole } from '@/utils/roles';
import styles from './AdminUsers.module.scss';

export const roleStyle = (role: UserRole) =>
  ({
    [USER_ROLES.SUPER_ADMIN]: styles.superAdmin,
    [USER_ROLES.COACH]: styles.coach,
    [USER_ROLES.USER]: styles.user,
  })[role];
